var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "row" }, [
    _c("div", { staticClass: "col-sm-12" }, [
      _c("div", { staticClass: "row mb-3" }, [
        _c("div", { staticClass: "col-sm-auto" }, [
          _c("h1", { staticClass: "content-title" }, [
            _vm._v(_vm._s(_vm.titleItem)),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "row" }, [
        _c(
          "div",
          { staticClass: "col-sm-4" },
          [
            _c(
              "MaterialInput",
              {
                staticClass: "city-form-group city-bg",
                attrs: {
                  readonly: _vm.readonly,
                  disabled: _vm.readonly,
                  id: "input-channel",
                  name: "channel",
                  value: _vm.channelText,
                },
                scopedSlots: _vm._u([
                  {
                    key: "grpAppend",
                    fn: function () {
                      return [
                        _c(
                          "div",
                          { staticClass: "d-flex align-items-center px-2" },
                          [_c("i", { class: _vm.icon })]
                        ),
                      ]
                    },
                    proxy: true,
                  },
                ]),
              },
              [
                _vm._v(
                  "\n                    " +
                    _vm._s(_vm.$t(`${_vm.pageID}.model.channel`)) +
                    "\n                "
                ),
              ]
            ),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "col-sm-4" },
          [
            _c(
              "MaterialInput",
              {
                staticClass: "city-form-group city-bg",
                attrs: {
                  readonly: _vm.readonly,
                  disabled: _vm.readonly,
                  id: "input-module",
                  name: "module",
                  value: _vm.moduleName,
                },
              },
              [
                _vm._v(
                  "\n                    " +
                    _vm._s(_vm.$t(`${_vm.pageID}.model.module`)) +
                    "\n                "
                ),
              ]
            ),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "col-sm-4" },
          [
            _c(
              "MaterialDatePicker",
              {
                staticClass: "city-form-group city-bg",
                attrs: {
                  disabled: _vm.readonly,
                  id: "input-created_at",
                  name: "created_at",
                  value: _vm.createdAt,
                  dateFormat: _vm.dateFormat,
                },
              },
              [
                _vm._v(
                  "\n                    " +
                    _vm._s(_vm.$t(`${_vm.pageID}.model.created_at`)) +
                    "\n                "
                ),
              ]
            ),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c("hr"),
      _vm._v(" "),
      _c("div", { staticClass: "row" }, [
        _c(
          "div",
          { staticClass: "col-sm-12" },
          [
            _c(
              "MaterialInput",
              {
                staticClass: "city-form-group city-bg",
                attrs: {
                  readonly: _vm.readonly,
                  disabled: _vm.readonly,
                  id: "input-to",
                  name: "to",
                  value: _vm.to,
                },
              },
              [
                _vm._v(
                  "\n                    " +
                    _vm._s(_vm.$t(`${_vm.pageID}.model.to`)) +
                    "\n                "
                ),
              ]
            ),
          ],
          1
        ),
        _vm._v(" "),
        _vm.isEmail
          ? _c(
              "div",
              { staticClass: "col-sm-6" },
              [
                _c(
                  "MaterialInput",
                  {
                    staticClass: "city-form-group city-bg",
                    attrs: {
                      readonly: _vm.readonly,
                      disabled: _vm.readonly,
                      id: "input-cc",
                      name: "cc",
                      value: _vm.cc,
                    },
                  },
                  [
                    _vm._v(
                      "\n                    " +
                        _vm._s(_vm.$t(`${_vm.pageID}.model.cc`)) +
                        "\n                "
                    ),
                  ]
                ),
              ],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.isEmail
          ? _c(
              "div",
              { staticClass: "col-sm-6" },
              [
                _c(
                  "MaterialInput",
                  {
                    staticClass: "city-form-group city-bg",
                    attrs: {
                      readonly: _vm.readonly,
                      disabled: _vm.readonly,
                      id: "input-bcc",
                      name: "bcc",
                      value: _vm.bcc,
                    },
                  },
                  [
                    _vm._v(
                      "\n                    " +
                        _vm._s(_vm.$t(`${_vm.pageID}.model.bcc`)) +
                        "\n                "
                    ),
                  ]
                ),
              ],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.isEmail
          ? _c(
              "div",
              { staticClass: "col-sm-12" },
              [
                _c(
                  "MaterialInput",
                  {
                    staticClass: "city-form-group city-bg",
                    attrs: {
                      readonly: _vm.readonly,
                      disabled: _vm.readonly,
                      id: "input-subject",
                      name: "subject",
                      value: _vm.subject,
                    },
                  },
                  [
                    _vm._v(
                      "\n                    " +
                        _vm._s(_vm.$t(`${_vm.pageID}.model.subject`)) +
                        "\n                "
                    ),
                  ]
                ),
              ],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _c("div", { staticClass: "col-sm-12" }, [
          _c("div", { staticClass: "form-group city-form-group city-bg" }, [
            _c("label", { staticClass: "city-label active" }, [
              _vm._v(_vm._s(_vm.$t(`${_vm.pageID}.model.message`))),
            ]),
            _vm._v(" "),
            _c("div", {
              staticClass: "form-control city-container",
              attrs: { readonly: "readonly" },
              domProps: { innerHTML: _vm._s(_vm.message) },
            }),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "row" }, [
        _c(
          "div",
          { staticClass: "col-12" },
          [
            _c("buttons-footer", {
              attrs: { enableButtons: !_vm.readonly },
              on: { cancel: _vm.handleBack },
            }),
          ],
          1
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }